<div class="modal-header">
  <h5 class="modal-title">Refer Gmail contacts</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeThisDialog()"></button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12 mb-3">
      <input [(ngModel)]="searchText" type="text" class="form-control live-search-gmail"
             placeholder="Search for email addresses">
    </div>

    <div class="col-12">
      <div class="contact-list">
        <div class="contact-list-all">
          @for (contact of this.contactList | filter:'email':searchText; track contact) {
            <div class="contact-row form-check">
              <input [(ngModel)]="contact.checked" type="checkbox" class="form-check-input email"
                     [value]="contact.email" [id]="'contact_row_' + contact.email">
              <label class="form-check-label" [for]="'contact_row_' + contact.email">
                <span class="contact-email">{{ contact.email }}</span>
              </label>
            </div>
          }
        </div>
      </div>

      <!-- Selection Controls -->
      <div class="contact-select-all text-end mt-2">
        <button type="button" class="btn btn-link p-0 me-3" (click)="selecteAll()">Select All</button>
        <button type="button" class="btn btn-link p-0" (click)="DeselecteAll()">Unselect All</button>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-end">
  <button type="button" class="btn btn-primary referCandidatesButton" (click)="referCandidates()" [disabled]="!contactList.some(c => c.checked)">
    Refer candidates
  </button>
</div>
